"use client"
import "./OtpPopup.css"
import { getAuthMessage } from "../../lib/constants/authStatusCodes"

const OtpPopup = ({ isVisible, onClose, status = "sent", message = "", errorTitle = "" }) => {

  if (!isVisible) return null

  const isSent = status === "sent"
  const isVerified = status === "verified"
  const isError = status === "error"
  const displayErrorTitle = isError ? (errorTitle || getAuthMessage("INVALID_OTP")) : ""
  const displayErrorMessage = isError ? (message || getAuthMessage("INVALID_OTP")) : ""


  return (
    <>
      <div className="otp-popup-overlay" onClick={onClose} />
      <div className="otp-popup-container">
        <div className={`otp-popup-card ${isSent ? "status-sent" : isError ? "status-error" : "status-verified"}`}>
          {isError ? (
            <svg width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="8" stroke="#FF4444" strokeWidth="1.5" fill="none" />
              <path d="M6 6L12 12M6 12L12 6" stroke="#FF4444" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539" stroke="#34CC35" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16.5 3L9 10.5075L6.75 8.2575" stroke="#34CC35" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}


          <div className={`otp-popup-content ${isVerified ? "verified" : ""}`}>
            <div className="otp-popup-title-section">
              <div className={`otp-popup-title ${isError ? "otp-popup-title-error" : ""}`}>
                {isSent ? (message || getAuthMessage("OTP_SENT")) : isError ? displayErrorTitle : (message || getAuthMessage("VERIFIED"))}
              </div>
            </div>

            <div className="otp-popup-message-section">
              <div className="otp-popup-message">
                {isSent
                  ? getAuthMessage("EMAIL_OTP_REQUIRED")
                  : isError
                    ? displayErrorMessage
                    : getAuthMessage("VERIFIED")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OtpPopup
